import * as React from 'react';

const TextWrappingWrap = (props:any) => (
    <svg width={20} height={20} viewBox="0 0 20 20" {...props}>
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <path d="M3.33333333,15.8333333 L8.33333333,15.8333333 L8.33333333,14.1666667 L3.33333333,14.1666667 L3.33333333,15.8333333 Z M16.6666667,4.16666667 L3.33333333,4.16666667 L3.33333333,5.83333333 L16.6666667,5.83333333 L16.6666667,4.16666667 Z M14.1666667,9.16666667 L3.33333333,9.16666667 L3.33333333,10.8333333 L14.375,10.8333333 C15.2916667,10.8333333 16.0416667,11.5833333 16.0416667,12.5 C16.0416667,13.4166667 15.2916667,14.1666667 14.375,14.1666667 L12.5,14.1666667 L12.5,12.5 L10,15 L12.5,17.5 L12.5,15.8333333 L14.1666667,15.8333333 C16.0083333,15.8333333 17.5,14.3416667 17.5,12.5 C17.5,10.6583333 16.0083333,9.16666667 14.1666667,9.16666667 Z" fill="currentColor" fillRule="nonzero" />
            <polygon points="0 0 20 0 20 20 0 20" />
        </g>
    </svg>
);

export default TextWrappingWrap;

